import { Form, Input, Upload } from 'antd';
import { ButtonLink } from '../../../../components';

const CustomUpload = () => (
  <Upload 
    showUploadList={false}>
    <Form.Item name="projPaper">
      <Input
        style={{ width: "135%" }}
        className="inputForm"
        suffix={<ButtonLink>Upload</ButtonLink>}
        name="projPaper"
      />
    </Form.Item>
  </Upload>
);

export default CustomUpload;